<template>
  <div id="EditEnrollContact" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回活動小組長列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <div class="form-group">
            <table class="table" style="width: 100%; align: left">
              <tbody style="width: 70%; align: left">
                <tr class="table-success" align="left">
                  <td>
                    <div>
                      <span class="red_star">＊</span>姓名:
                      <input
                        type="text"
                        class="form-control"
                        v-model="inputData[0].name"
                        placeholder="請輸入姓名"
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <span class="red_star">＊</span>手機電話:
                      <input
                        type="text"
                        class="form-control"
                        v-model="inputData[0].cellPhone"
                        placeholder="請輸入手機電話"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="editEnrollContact()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "EditEnrollContact",
  props: ["sn"],

  data() {
    return {
      RowId: "",
      AttachContent: [],
      mode: false,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: [
        {
          sn: 0,
          name: null,
          cellPhone: null,
        },
      ],
      currentPage: 1,

      pageSize: 10,
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    hideModal(name) {
      this.$refs[name].hide();
    },

    checkInput() {
      this.inputFlag = false;

      if (tools.empty(this.inputData[0].name)) {
        alert("請輸入姓名");
        this.inputFlag = true;
        return;
      }

      if (!tools.isValidPhoneNumber(this.inputData[0].cellPhone)) {
        alert("請輸入正確手機電話");
        this.inputData.cellPhone = "";
        this.inputFlag = true;
        return;
      }
    },

    editEnrollContact() {
      this.checkInput();
      let vm = this;

      if (this.inputFlag != true) {
        this.$http
          .put(
            "./WebApi/HighSchoolEnrolling/EditEnrollContact/",
            this.inputData[0]
          )
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "更新活動小組長成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,更新活動小組長失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },

    close() {
      this.$emit("hideModal");
    },
  },
  created() {
    console.log("======created EditEnrollContactView =====");

    let vm = this;

    vm.inputData[0].sn = this.$props.sn;
    this.$http
      .get(
        "../WebApi/HighSchoolEnrolling/GetEnrollContactDetail/".concat(
          vm.inputData[0].sn
        )
      )
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data;
        }
      })
      .catch(function (error) {
        alert("網路連線失敗" + error);
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
